import React from 'react';
import cx from 'classnames';

import { Content } from 'LegacySBCRA/Content/Content';

import { IconCard } from '../../../../../storybook/components/local/IconCard/IconCard';
import { usePageRefEvents } from '../../../common/Hooks/usePageRefEvents';

import { motContentBody, taxContentBody } from './CheckerInfoSection.helpers';

import styles from './CheckerInfoSection.scss';

type CheckerInfoSectionProps = {
  acf: Record<string, string>;
  isMotCheck: boolean;
  onLoad: () => void;
}

export const CheckerInfoSection = ({ acf, isMotCheck, onLoad }: CheckerInfoSectionProps) => {
  const { setRef } = usePageRefEvents({ onRefTrigger: onLoad });

  const contentBody = isMotCheck ? motContentBody : taxContentBody;
  return (
    <Content className={styles.component} wrapper={{ className: cx(styles.componentWrapper) }}>
      <div ref={(ref) => setRef(ref)} data-testid='checker-info'>
        <h2 className={styles.chargesTitle}>
          {acf?.ulez_section_title}
        </h2>
        <div
          dangerouslySetInnerHTML={{ __html: acf?.ulez_section_body }}
          className={styles.chargesDesc}
        />
        <section className={styles.chargesBoxes}>
          {contentBody(acf)?.map(({
            contentBodyArea,
            id,
            imgSrc,
            title,
          }) => (<IconCard key={id} {...{
            contentBodyArea,
            imgSrc,
            title,
          }} />))}
        </section>
      </div>
    </Content>
  );
};
